import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import Img1 from "./Img1.png";
import Img2 from "./Img2.png";
import Img3 from "./Img3.png";
import Img4 from "./Img4.png";
import Img5 from "./Img5.png";
import Img6 from "./Img6.png";
import Arrow from "../testimonial/arrow.png";
import styles from "./testimonial.module.css"; // Import the CSS module

function Testimonial1() {
  const [carouselStyle, setCarouselStyle] = useState({
    width: "65%",
    margin: "1px auto",
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1008) {
        setCarouselStyle({
          width: "90%",
          margin: "1px auto",
        });
      } else if (window.innerWidth <= 576) {
        setCarouselStyle({
          width: "100%",
          margin: "1px auto",
        });
      } else {
        setCarouselStyle({
          width: "80%",
          margin: "1px auto",
        });
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize(); // Initial call
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={styles.crouselbox} id="crouselboxid">
      <style>
        {`
           
          .carousel-control-next {
                position: absolute;
                left: 53%;
                top: 110%;
                transform: translate(-50%, -50%);
                height: 2rem !important;
                width: 2rem !important;
            }
          .carousel-control-prev {
                position: absolute;
                left: 47%;
                top: 110%;
                transform: translate(-50%, -50%);
                height: 2rem !important;
                width: 2rem !important;
          }
          .carousel-indicators {
            display: none;
          }
          .carousel-control-prev-icon,
          .carousel-control-next-icon {
            background-color: white;
            background-size: cover;
            width: 1.8rem;
            height: 1.2rem;
          }
          .carousel-control-prev-icon,
          .carousel-control-next-icon {
            background-color: white;
            background-size: cover;
          }
          .carousel-control-prev-icon {
            background-image: url(${Arrow});
            transform: rotate(180deg);
          }
          .carousel-control-next-icon {
            background-image: url(${Arrow});
          }
          .carousel-item>img{

          }
          .carousel-item > div {
            display: flex;
            gap: 1rem;
            align-items: center;
            justify-content: center;
            height: 15rem;
          }
          @media screen and (max-width: 1000px) {
            .carousel-item {
                position: relative;
                height: 40rem !important;
            }
            .carousel-item > img {
                position: absolute !important;
                {/* left: 30% !important;
                bottom: 41% !important; */}
                top: 27% !important;
                left: 50% !important;
                transform: translate(-50%, 0%) !important;
            }
            .carousel-control-next {
                position: absolute;
                left: 55%!important;
                top: 95%!important;
                transform: translate(-50%, -50%);
                height: 2rem !important;
                width: 2rem !important;
            }
          .carousel-control-prev {
                position: absolute;
                left: 45%!important;
                top: 95%!important;
                transform: translate(-50%, -50%);
                height: 2rem !important;
                width: 2rem !important;
          }
            }
          @media screen and (max-width: 767px) {
            .carousel-item > img {
                left: 50% !important;
                transform: translate(-50%, 0%) !important;
            }
            }
            {/* .carousel-control-next {
                position: absolute;
                left: 57%!important;
                transform: translate(-50%, -50%);
                height: 2rem !important;
                width: 2rem !important;
            }
          .carousel-control-prev {
                position: absolute;
                left: 43%!important;
                transform: translate(-50%, -50%);
                height: 2rem !important;
                width: 2rem !important;
          } */}
          {/* @media screen and (max-width: 495px) {
            .carousel-item > img {
                position: absolute !important;
                left: 21% !important;
                bottom: 41% !important;
            }
            }
          @media screen and (max-width: 400px) {
            .carousel-item > img {
                position: absolute !important;
                left: 18% !important;
                bottom: 41% !important;
            }
            } */}
          @media screen and (max-width: 375px) {
            .carousel-item > img {
                width: 10rem !important;
                left: 50% !important;
                transform: translate(-50%, 0%) !important;
            }
            .carousel-item {
    position: relative;
    height: 33rem !important;
}
            .carousel-control-next {
                position: absolute;
                left: 58%!important;
                top: 100%!important;
                transform: translate(-50%, -50%);
                height: 2rem !important;
                width: 2rem !important;
            }
          .carousel-control-prev {
                position: absolute;
                left: 42%!important;
                top: 100%!important;
                transform: translate(-50%, -50%);
                height: 2rem !important;
                width: 2rem !important;
          }
            }
          {/* @media screen and (max-width: 350px) {
            .carousel-item > img {
                position: absolute !important;
                width: 13rem!important;
                left: 14% !important;
                bottom: 41% !important;
            }
            } */}
          {/* @media screen and (max-width: 325px) {
            .carousel-item > img {
                position: absolute !important;
                width: 13rem!important;
                left: 10% !important;
                bottom: 41% !important;
            }
            } */}

        `}
      </style>
      <Carousel style={carouselStyle}>
        <Carousel.Item>
          <img src={Img1} alt="First slide" style={{ width: "15rem" }} />
          <Carousel.Caption className={styles.carouselCaption}>
            <p className={styles.carouselCaptionP}>
              “Udaya Solution redefined our approach to HR. Their strategic
              consulting transformed how we manage talent acquisition and
              employee engagement. We've seen a marked improvement in workforce
              productivity and overall job satisfaction across the board.”
            </p>
            <div className={styles.carouselCaptiondiv}>
              Rajesh Malhotra - Head of Operations, Apex Technologies
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={Img2} alt="Second slide" style={{ width: "15rem" }} />
          <Carousel.Caption className={styles.carouselCaption}>
            <p className={styles.carouselCaptionP}>
              “The expert guidance from Udaya Solution helped us revamp our
              recruitment strategy, making it more targeted and efficient. Their
              tailored solutions not only saved us time but ensured that we
              hired the right candidates who fit our company culture.”
            </p>
            <div className={styles.carouselCaptiondiv}>
            Emma Thompson - HR Manager, Tech Innovators Inc
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={Img3} alt="Third slide" style={{ width: "15rem" }} />
          <Carousel.Caption className={styles.carouselCaption}>
            <p className={styles.carouselCaptionP}>
              “Our collaboration with Udaya Solution has been pivotal in shaping
              our HR strategy. From recruitment to employee retention, their
              solutions have helped us build a robust and motivated team. We’ve
              seen outstanding results in both team performance and retention.”
            </p>
            <div className={styles.carouselCaptiondiv}>
              Mohan Batra - Director of Human Resources, Nexus Corp
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={Img4} alt="Fourth slide" style={{ width: "15rem" }} />
          <Carousel.Caption className={styles.carouselCaption}>
            <p className={styles.carouselCaptionP}>
              “Udaya Solution’s team is incredibly responsive and knowledgeable.
              Their strategic HR interventions have helped us streamline
              internal processes, boosting both efficiency and employee morale.
              We now have a stronger, more unified workforce.”
            </p>
            <div className={styles.carouselCaptiondiv}>
            Priya Verma - Chief Operations Officer, Global FinTech
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={Img5} alt="Fifth slide" style={{ width: "15rem" }} />
          <Carousel.Caption className={styles.carouselCaption}>
            <p className={styles.carouselCaptionP}>
              “The personalized approach Udaya Solution offers is second to
              none. Their ability to understand the intricacies of our industry
              and deliver precise HR solutions has been instrumental in our
              growth. I highly recommend their services for any business looking
              to optimize their workforce management.”
            </p>
            <div className={styles.carouselCaptiondiv}>
              Karan Mehta - Senior HR Manager, Evolve Tech Solutions
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={Img6} alt="Sixth slide" style={{ width: "15rem" }} />
          <Carousel.Caption className={styles.carouselCaption}>
            <p className={styles.carouselCaptionP}>
              “Udaya Solution’s expertise in HR consulting has been a
              game-changer for us. Their hands-on approach and commitment to
              finding the right talent has significantly reduced our hiring time
              and costs, while also improving employee retention.”
            </p>
            <div className={styles.carouselCaptiondiv}>
            Sanya Mehta - VP of Talent Acquisition, TechWave Systems
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default Testimonial1;
